window.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(min-width: 750px)').matches) {
      return
    }
  
    const handleCollapse = (heading) => {
      if (heading.classList.contains('collapsed')) {
        heading.classList.remove('collapsed')
        heading.setAttribute('aria-expanded', 'true')
      } else {
        heading.classList.add('collapsed')
        heading.setAttribute('aria-expanded', 'false')
      }
    }
    
    document.querySelectorAll('.grid__item .footer-block__heading').forEach((heading, index) => {
      heading.classList.add('collapsed')
      heading.setAttribute('role', 'button')
      heading.setAttribute('aria-expanded', 'false')
      heading.setAttribute('tabindex', '0')
  
      heading.nextElementSibling.setAttribute('id', `footer-block__index__${index}`)
      heading.setAttribute('aria-controls', `footer-block__index__${index}`)
  
      heading.addEventListener('click', () => { handleCollapse(heading) })
      heading.addEventListener('keypress',  () => { handleCollapse(heading) })
    })
  
  });

window.addEventListener('DOMContentLoaded', () => {
  const checkDiv = setInterval(() => {
    const userwayIcon = document.querySelector('#userwayAccessibilityIcon img');
    if(userwayIcon) {
      clearInterval(checkDiv);
      userwayIcon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0565/1011/9989/files/Accessibility_logo.png?v=1677789372');
      document.querySelector('#userwayAccessibilityIcon').style.backgroundColor = '#f9fafc !important';
    } 
  }, 100);
});